import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserPermissionsService } from 'rome-library';
import { Observable } from 'rxjs';
import { WritingBusinessInfoDto } from '../models/writing-business-info-dto.model';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class BrokerUserService extends UserService {
  constructor(httpClient: HttpClient, userPermissionService: UserPermissionsService) {
    super(httpClient, userPermissionService);
  }

  public getUserInfoEndpoint(): string {
    return '/Agents/currentUserInfo';
  }

  public getSendResetForgottenPasswordRequestEndpoint(): string {
    return '/Agents/sendResetForgottenPasswordRequest';
  }

  public getResetForgottenPasswordRequestEndpoint(): string {
    return '/Agents/resetForgottenPassword';
  }

  public getSecurityChallengeForPasswordResetRequestEndpoint(): string {
    return '/Agents/securityQuestionForPasswordResetRequest';
  }

  public getCheckSecurityQuestionAnswerForPasswordResetRequestEndpoint(): string {
    return '/Agents/checkSecurityQuestionAnswerForPasswordResetRequest';
  }

  public getResetPasswordEndpoint(): string {
    return '/ExternalAgents/resetAgentPassword';
  }

  public getAgentWritingBusinessData(userId: string): Observable<WritingBusinessInfoDto> {
    return this.httpClient.get<WritingBusinessInfoDto>('/ExternalAgents/GetAgentWritingBusinessData', {
      params: {
        userId
      }
    });
  }

  public acceptCookies(): Observable<any> {
    return this.httpClient.put('/ExternalAgents/acceptCookies', {});
  }

  public getCookiesResponse(): Observable<boolean> {
    return this.httpClient.get<boolean>('/ExternalAgents/hasAcceptedCookies', {});
  }
}
